const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const settingDocRouter = new VueRouter({
  routes: [
    {
      name: 'docs-tos',
      path: '/tos',
      component: require('./components/pages/setting-docs/View.vue').default,
      props: { docKey: 'tos' }
    },
    {
      name: 'docs-fee',
      path: '/fee',
      component: require('./components/pages/setting-docs/View.vue').default,
      props: { docKey: 'fee' }
    },
  ],
})

Vue.component('setting-docs-entry', require('./components/pages/setting-docs/Index.vue').default)

if ($('#setting-docs-app').length) { // for deposit-app
  const app = new Vue({
    router: settingDocRouter
  }).$mount('#setting-docs-app');
}